import { Component, ViewEncapsulation, Input } from '@angular/core';
import { Address } from '../../models/address/address';
import { InvestmentPropertyPreview } from '../../models/investment-property/investment-property-preview';

@Component({
    selector: 'investment-property-preview-card',
    templateUrl: './investment-property-preview-card.component.html',
    encapsulation: ViewEncapsulation.None
})

export class InvestmentPropertyPreviewCardComponent {

    @Input() investmentPropertyPreview: InvestmentPropertyPreview;
    @Input() majorArea: Address;
    @Input() showAddress: boolean = false;

    constructor() {
        if (!this.majorArea && this.investmentPropertyPreview && !this.investmentPropertyPreview.majorArea) {
            this.investmentPropertyPreview.majorArea = this.majorArea;
        }
    }
}
